module.exports = __webpack_public_path__ + "img/excellence4.76e5630c.png";